// BBTB
export const BBTB_VEGGIE = 'CMG-4005' // protein
export const BBTB_STEAK = 'CMG-4001' // protein
export const BBTB_SOFRITAS = 'CMG-4006' // protein
export const BBTB_CHICKEN = 'CMG-4002' // protein
export const BBTB_CARNITAS = 'CMG-4003' // protein
export const BBTB_WHITE_RICE = 'CMG-5001' // base
export const BBTB_BARBACOA = 'CMG-4004' // protein
export const BBTB_BROWN_RICE = 'CMG-5002' // base

// TRIPLE -----------------------------------------
export const TRIPLE_WHITE_RICE = 'CMG-4307' // base
export const TRIPLE_BROWN_RICE = 'CMG-4308' // base
export const TRIPLE_BLACK_BEANS = 'CMG-4310' // base
export const TRIPLE_SALAD_LETTUCE = 'CMG-4309' // base
export const TRIPLE_PINTO_BEANS = 'CMG-4311' // base

export const TRIPLE_PROTEIN_GUACAMOLE = 'CMG-4317' // protein
export const TRIPLE_PROTEIN_STEAK = 'CMG-4313' // protein
export const TRIPLE_PROTEIN_CARNITAS = 'CMG-4314' // protein
export const TRIPLE_PROTEIN_CHORIZO = 'CMG-4330' // protein
export const TRIPLE_PROTEIN_BARBACOA = 'CMG-4315' // protein
export const TRIPLE_PROTEIN_SOFRITAS = 'CMG-4316' // protein
export const TRIPLE_PROTEIN_CHICKEN = 'CMG-4312' // protein

export const TRIPLE_PROTEIN_QUESO_TOPPING = 'CMG-4323' // prem
export const TRIPLE_PROTEIN_WHITE_QUESO_TOPPING = 'CMG-4133' // prem
export const TRIPLE_PROTEIN_GUACAMOLE_TOPPING = 'CMG-4322' // prem
// salsas
export const TRIPLE_SALSA_HOT_RED = 'CMG-4327' // salsa
export const TRIPLE_SALSA_MILD_TOMATO = 'CMG-4324' // salsa
export const TRIPLE_SALSA_MEDIUM_GREEN = 'CMG-4325' // salsa
export const TRIPLE_SALSA_MEDIUM_CORN = 'CMG-4326' // salsa

// Toppings
export const TRIPLE_TOPPINGS_TACO_LETTUCE = 'CMG-4318' // toppings
export const TRIPLE_TOPPINGS_CHEESE = 'CMG-4320' // toppings
export const TRIPLE_TOPPINGS_VEGGIE = 'CMG-4319' // toppings
export const TRIPLE_TOPPINGS_SOUR_CREAM = 'CMG-4321' // toppings

// Tortillas
export const TRIPLE_TORTILLAS_CORN = 'CMG-4328'
export const TRIPLE_TORTILLAS_FLOUR = 'CMG-4329'
// -----------------------------------------------------

// DOUBLE
export const DOUBLE_PINTO_BEANS = 'CMG-4211' // base
export const DOUBLE_BLACK_BEANS = 'CMG-4210' // base
export const DOUBLE_BROWN_RICE = 'CMG-4208' // base
export const DOUBLE_SALAD_LETTUCE = 'CMG-4209' // base
export const DOUBLE_WHITE_RICE = 'CMG-4207' // base
// proteins
export const DOUBLE_PROTEIN_GUACAMOLE = 'CMG-4217' // protein
export const DOUBLE_PROTEIN_STEAK = 'CMG-4213' // protein
export const DOUBLE_PROTEIN_CARNITAS = 'CMG-4214' // protein
export const DOUBLE_PROTEIN_CHORIZO = 'CMG-4230' // protein
export const DOUBLE_PROTEIN_BARBACOA = 'CMG-4215' // protein
export const DOUBLE_PROTEIN_SOFRITAS = 'CMG-4216' // protein
export const DOUBLE_PROTEIN_CHICKEN = 'CMG-4212' // protein

// Toppings
export const DOUBLE_TOPPINGS_TACO_LETTUCE = 'CMG-4218' // toppings
export const DOUBLE_TOPPINGS_CHEESE = 'CMG-4220' // toppings
export const DOUBLE_TOPPINGS_VEGGIE = 'CMG-4219' // toppings
export const DOUBLE_TOPPINGS_SOUR_CREAM = 'CMG-4221' // toppings
// premium
export const DOUBLE_PROTEIN_QUESO_TOPPING = 'CMG-4223' // prem
export const DOUBLE_PROTEIN_WHITE_QUESO_TOPPING = 'CMG-4132' // prem
export const DOUBLE_PROTEIN_GUACAMOLE_TOPPING = 'CMG-4222' // prem
// salsas
export const DOUBLE_SALSA_HOT_RED = 'CMG-4227' // salsa
export const DOUBLE_SALSA_MILD_TOMATO = 'CMG-4224' // salsa
export const DOUBLE_SALSA_MEDIUM_GREEN = 'CMG-4225' // salsa
export const DOUBLE_SALSA_MEDIUM_CORN = 'CMG-4226' // salsa
// Tortillas
export const DOUBLE_TORTILLAS_CORN = 'CMG-4228'
export const DOUBLE_TORTILLAS_FLOUR = 'CMG-4229'
// -----------------------------------------------------
// SINGLE ----------------------------------------------
export const SINGLE_PINTO_BEANS = 'CMG-4110' // base
export const SINGLE_BLACK_BEANS = 'CMG-4109' // base
export const SINGLE_BROWN_RICE = 'CMG-4107' // base
export const SINGLE_SALAD_LETTUCE = 'CMG-4108' // base
export const SINGLE_WHITE_RICE = 'CMG-4106' // base
// proteins
export const SINGLE_PROTEIN_GUACAMOLE = 'CMG-4116' // protein
export const SINGLE_PROTEIN_STEAK = 'CMG-4112' // protein
export const SINGLE_PROTEIN_CARNITAS = 'CMG-4113' // protein
export const SINGLE_PROTEIN_CHORIZO = 'CMG-4129' // protein
export const SINGLE_PROTEIN_BARBACOA = 'CMG-4114' // protein
export const SINGLE_PROTEIN_SOFRITAS = 'CMG-4115' // protein
export const SINGLE_PROTEIN_CHICKEN = 'CMG-4111' // protein

// Toppings
export const SINGLE_TOPPINGS_TACO_LETTUCE = 'CMG-4117' // toppings
export const SINGLE_TOPPINGS_CHEESE = 'CMG-4119' // toppings
export const SINGLE_TOPPINGS_VEGGIE = 'CMG-4118' // toppings
export const SINGLE_TOPPINGS_SOUR_CREAM = 'CMG-4120' // toppings
// premium
export const SINGLE_PROTEIN_QUESO_TOPPING = 'CMG-4122' // prem
export const SINGLE_PROTEIN_WHITE_QUESO_TOPPING = 'CMG-4131' // prem
export const SINGLE_PROTEIN_GUACAMOLE_TOPPING = 'CMG-4121' // prem
// salsas
export const SINGLE_SALSA_HOT_RED = 'CMG-4126' // salsa
export const SINGLE_SALSA_MILD_TOMATO = 'CMG-4123' // salsa
export const SINGLE_SALSA_MEDIUM_GREEN = 'CMG-4124' // salsa
export const SINGLE_SALSA_MEDIUM_CORN = 'CMG-4125' // salsa
// Tortillas
export const SINGLE_TORTILLAS_CORN = 'CMG-4127'
export const SINGLE_TORTILLAS_FLOUR = 'CMG-4128'
// ------------------------------------------------------
// CHIPS AND SALSA---------------------------------------
export const CHIPS_SALSA_GUACAMOLE = 'CMG-4029' // prem
export const CHIPS_SALSA_QUESO = 'CMG-4028' // prem
export const CHIPS_SALSA_WHITE_QUESO = 'CMG-4032' // prem

export const CATEGORY_BASE = 'category-base'
export const CATEGORY_PROTEIN = 'category-protein'
export const CATEGORY_TOPPING = 'category-topping'
export const CATEGORY_PREMIUM = 'category-premium'
export const CATEGORY_SALSA = 'category-salsa'
export const CATEGORY_TORTILLA = 'category-tortilla'
export const CATEGORY_ORDER_TYPE = 'category-order-type'

export const CHIPS_AND_SALSA = 'CMG-4027'
export const BURRITO_BY_THE_BOX = 'CMG-4012'
export const SINGLE = 'CMG-4105'
export const DOUBLE = 'CMG-4206'
export const TRIPLE = 'CMG-4306'

export const MenuCategory = {}
// order types
MenuCategory[CHIPS_AND_SALSA] = CATEGORY_ORDER_TYPE
MenuCategory[BURRITO_BY_THE_BOX] = CATEGORY_ORDER_TYPE
// items
MenuCategory[CHIPS_SALSA_GUACAMOLE] = CATEGORY_PREMIUM
MenuCategory[CHIPS_SALSA_QUESO] = CATEGORY_PREMIUM
MenuCategory[CHIPS_SALSA_WHITE_QUESO] = CATEGORY_PREMIUM
MenuCategory[TRIPLE_PROTEIN_QUESO_TOPPING] = CATEGORY_PREMIUM
MenuCategory[TRIPLE_PROTEIN_WHITE_QUESO_TOPPING] = CATEGORY_PREMIUM
MenuCategory[TRIPLE_PROTEIN_GUACAMOLE_TOPPING] = CATEGORY_PREMIUM
MenuCategory[DOUBLE_PROTEIN_QUESO_TOPPING] = CATEGORY_PREMIUM
MenuCategory[DOUBLE_PROTEIN_WHITE_QUESO_TOPPING] = CATEGORY_PREMIUM
MenuCategory[DOUBLE_PROTEIN_GUACAMOLE_TOPPING] = CATEGORY_PREMIUM
MenuCategory[SINGLE_PROTEIN_QUESO_TOPPING] = CATEGORY_PREMIUM
MenuCategory[SINGLE_PROTEIN_WHITE_QUESO_TOPPING] = CATEGORY_PREMIUM
MenuCategory[SINGLE_PROTEIN_GUACAMOLE_TOPPING] = CATEGORY_PREMIUM

MenuCategory[TRIPLE_WHITE_RICE] = CATEGORY_BASE
MenuCategory[TRIPLE_BROWN_RICE] = CATEGORY_BASE
MenuCategory[TRIPLE_BLACK_BEANS] = CATEGORY_BASE
MenuCategory[TRIPLE_SALAD_LETTUCE] = CATEGORY_BASE
MenuCategory[TRIPLE_PINTO_BEANS] = CATEGORY_BASE
MenuCategory[DOUBLE_PINTO_BEANS] = CATEGORY_BASE
MenuCategory[DOUBLE_BLACK_BEANS] = CATEGORY_BASE
MenuCategory[DOUBLE_BROWN_RICE] = CATEGORY_BASE
MenuCategory[DOUBLE_SALAD_LETTUCE] = CATEGORY_BASE
MenuCategory[DOUBLE_WHITE_RICE] = CATEGORY_BASE
MenuCategory[SINGLE_PINTO_BEANS] = CATEGORY_BASE
MenuCategory[SINGLE_BLACK_BEANS] = CATEGORY_BASE
MenuCategory[SINGLE_BROWN_RICE] = CATEGORY_BASE
MenuCategory[SINGLE_SALAD_LETTUCE] = CATEGORY_BASE
MenuCategory[SINGLE_WHITE_RICE] = CATEGORY_BASE
MenuCategory[BBTB_BROWN_RICE] = CATEGORY_BASE
MenuCategory[BBTB_WHITE_RICE] = CATEGORY_BASE

MenuCategory[BBTB_VEGGIE] = CATEGORY_PROTEIN
MenuCategory[BBTB_STEAK] = CATEGORY_PROTEIN
MenuCategory[BBTB_SOFRITAS] = CATEGORY_PROTEIN
MenuCategory[BBTB_CHICKEN] = CATEGORY_PROTEIN
MenuCategory[BBTB_CARNITAS] = CATEGORY_PROTEIN
MenuCategory[BBTB_BARBACOA] = CATEGORY_PROTEIN
MenuCategory[TRIPLE_PROTEIN_GUACAMOLE] = CATEGORY_PROTEIN
MenuCategory[TRIPLE_PROTEIN_STEAK] = CATEGORY_PROTEIN
MenuCategory[TRIPLE_PROTEIN_CARNITAS] = CATEGORY_PROTEIN
MenuCategory[TRIPLE_PROTEIN_CHORIZO] = CATEGORY_PROTEIN
MenuCategory[TRIPLE_PROTEIN_BARBACOA] = CATEGORY_PROTEIN
MenuCategory[TRIPLE_PROTEIN_SOFRITAS] = CATEGORY_PROTEIN
MenuCategory[TRIPLE_PROTEIN_CHICKEN] = CATEGORY_PROTEIN
MenuCategory[DOUBLE_PROTEIN_GUACAMOLE] = CATEGORY_PROTEIN
MenuCategory[DOUBLE_PROTEIN_STEAK] = CATEGORY_PROTEIN
MenuCategory[DOUBLE_PROTEIN_CARNITAS] = CATEGORY_PROTEIN
MenuCategory[DOUBLE_PROTEIN_CHORIZO] = CATEGORY_PROTEIN
MenuCategory[DOUBLE_PROTEIN_BARBACOA] = CATEGORY_PROTEIN
MenuCategory[DOUBLE_PROTEIN_SOFRITAS] = CATEGORY_PROTEIN
MenuCategory[DOUBLE_PROTEIN_CHICKEN] = CATEGORY_PROTEIN
MenuCategory[SINGLE_PROTEIN_GUACAMOLE] = CATEGORY_PROTEIN
MenuCategory[SINGLE_PROTEIN_STEAK] = CATEGORY_PROTEIN
MenuCategory[SINGLE_PROTEIN_CARNITAS] = CATEGORY_PROTEIN
MenuCategory[SINGLE_PROTEIN_CHORIZO] = CATEGORY_PROTEIN
MenuCategory[SINGLE_PROTEIN_BARBACOA] = CATEGORY_PROTEIN
MenuCategory[SINGLE_PROTEIN_SOFRITAS] = CATEGORY_PROTEIN
MenuCategory[SINGLE_PROTEIN_CHICKEN] = CATEGORY_PROTEIN

MenuCategory[TRIPLE_SALSA_HOT_RED] = CATEGORY_SALSA
MenuCategory[TRIPLE_SALSA_MILD_TOMATO] = CATEGORY_SALSA
MenuCategory[TRIPLE_SALSA_MEDIUM_GREEN] = CATEGORY_SALSA
MenuCategory[TRIPLE_SALSA_MEDIUM_CORN] = CATEGORY_SALSA
MenuCategory[DOUBLE_SALSA_MILD_TOMATO] = CATEGORY_SALSA
MenuCategory[DOUBLE_SALSA_MEDIUM_GREEN] = CATEGORY_SALSA
MenuCategory[DOUBLE_SALSA_MEDIUM_CORN] = CATEGORY_SALSA
MenuCategory[SINGLE_SALSA_HOT_RED] = CATEGORY_SALSA
MenuCategory[SINGLE_SALSA_MILD_TOMATO] = CATEGORY_SALSA
MenuCategory[SINGLE_SALSA_MEDIUM_GREEN] = CATEGORY_SALSA
MenuCategory[SINGLE_SALSA_MEDIUM_CORN] = CATEGORY_SALSA
MenuCategory[TRIPLE_SALSA_HOT_RED] = CATEGORY_SALSA

MenuCategory[TRIPLE_TOPPINGS_TACO_LETTUCE] = CATEGORY_TOPPING
MenuCategory[TRIPLE_TOPPINGS_CHEESE] = CATEGORY_TOPPING
MenuCategory[TRIPLE_TOPPINGS_VEGGIE] = CATEGORY_TOPPING
MenuCategory[TRIPLE_TOPPINGS_SOUR_CREAM] = CATEGORY_TOPPING
MenuCategory[DOUBLE_TOPPINGS_TACO_LETTUCE] = CATEGORY_TOPPING
MenuCategory[DOUBLE_TOPPINGS_CHEESE] = CATEGORY_TOPPING
MenuCategory[DOUBLE_TOPPINGS_VEGGIE] = CATEGORY_TOPPING
MenuCategory[DOUBLE_TOPPINGS_SOUR_CREAM] = CATEGORY_TOPPING
MenuCategory[SINGLE_TOPPINGS_TACO_LETTUCE] = CATEGORY_TOPPING
MenuCategory[SINGLE_TOPPINGS_CHEESE] = CATEGORY_TOPPING
MenuCategory[SINGLE_TOPPINGS_VEGGIE] = CATEGORY_TOPPING
MenuCategory[SINGLE_TOPPINGS_SOUR_CREAM] = CATEGORY_TOPPING

MenuCategory[SINGLE_TORTILLAS_CORN] = CATEGORY_TORTILLA
MenuCategory[SINGLE_TORTILLAS_FLOUR] = CATEGORY_TORTILLA
MenuCategory[DOUBLE_TORTILLAS_CORN] = CATEGORY_TORTILLA
MenuCategory[DOUBLE_TORTILLAS_FLOUR] = CATEGORY_TORTILLA
MenuCategory[TRIPLE_TORTILLAS_CORN] = CATEGORY_TORTILLA
MenuCategory[TRIPLE_TORTILLAS_FLOUR] = CATEGORY_TORTILLA
